import { useTranslation } from 'react-i18next';
import type { ILawStakesProps } from './ILawStakesProps';
import { lawValue } from './lawGroups';
import { stanceTone } from './lawTones';

/**
 * «Зацікавлені сторони та їхні інтереси» (прототип v4 lzPeople): на «Зацікавлених сторонах» — матриця «Вплив ↓ · Позиція →» (рядки й колонки —
 * варіанти полів), у клітинках — сторони кольору позиції з інтересом у підказці; на «Інтересах» — плитки «Сторона · Позиція» й інтерес.
 * Архівні сторони не показуються.
 */
export function LawStakes({ law, labels, onOpen, list }: ILawStakesProps) {
  const { t } = useTranslation();
  const items = law.of('ldstake').filter((r) => r.status !== 'Archived');
  const stances = labels.order('ldstake', 'stance');
  const stance = (v: unknown) => labels.option('ldstake', 'stance', v);
  return (
    <section className="law-sec">
      <div className="law-sec__title">{t('recordPage.law.stakes')}</div>
      {list ? (
        <div className="law-int">
          {items.map((r) => (
            <div key={r.id} className={`law-int__item law-t-${stanceTone(r.values['stance'])}`}>
              <strong>{r.title} · {stance(r.values['stance'])}</strong>
              <span>{lawValue(r, 'interest')}</span>
            </div>
          ))}
        </div>
      ) : (
        <div className="law-mx__scroll">
          <div className="law-mx law-mx--stake">
            <div className="law-mx__corner">{t('recordPage.law.stakeCorner')}</div>
            {stances.map((s) => <div key={s} className="law-mx__head">{stance(s)}</div>)}
            {labels.order('ldstake', 'influence').map((inf) => (
              <div key={inf} className="law-mx__row">
                <div className="law-mx__label">{labels.option('ldstake', 'influence', inf)}</div>
                {stances.map((s) => (
                  <div key={s} className="law-mx__cell">
                    {items.filter((r) => lawValue(r, 'influence') === inf && lawValue(r, 'stance') === s).map((r) => (
                      <button key={r.id} type="button" className={`law-chip law-t-${stanceTone(s)}`} title={lawValue(r, 'interest')} onClick={() => onOpen('ldstake', r)}>
                        {r.title}
                      </button>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
